const brief_status = {
	0: "PENDING",
	1: "COMPLETED",
};

export default brief_status;
